module.exports = __webpack_public_path__ + "img/info_round_w.53fa8789.svg";